module.exports = __webpack_public_path__ + "static/Seated-3111dcaeae6e007060388beeeae53e87.jpg";